export const pascalCaseToString = (str: string) =>
  ((str = str.replace(/[A-Z]/g, ' $&')), str).toLocaleLowerCase();

export const AnyFormatToString = (status: string): string => {
  // Convert snake_case to space-separated words and lowercase
  let formattedStatus = status.replace(/_/g, ' ').toLowerCase();

  // Capitalize the first letter of each word
  formattedStatus = formattedStatus.replace(/\b\w/g, char =>
    char.toUpperCase()
  );

  // Handle camelCase by inserting space before capital letters and reapply formatting
  formattedStatus = formattedStatus
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return formattedStatus;
};
